export default {
      id: "common__generator-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__generator",
      toString: function () {
        return this.url;
      }
    }